/**
 * 数値フォーマット用ユーティリティ
 */

const ROUNDED_DECIMAL_PLACES = 3;

/**
 * 数値を指定した小数桁数で四捨五入してフォーマット
 */
export const formatToRoundedDecimal = (params: {
  value: number;
  decimalPlaces?: number;
}): string => {
  const places = params.decimalPlaces ?? ROUNDED_DECIMAL_PLACES;
  return params.value.toFixed(places);
};
